export default "assets/images/7bef6f357e921c43f4f800cfcb757872.png";